
class KorGrid {

    constructor(_id, _colsDef, _data, _options) {
        this.id = _id;
        this.container = document.getElementById(this.id);
        this.colsDef = _colsDef;
        this.data = _data;
        this.activeFilters = [];
        this.sortBy = "";
        this.sortDesc = false;
        this.sortSpans = [];

        this.height = _options.height ? _options.height : 450;

        this.init();
    }

    init() {
        this.container.style.height = this.height + "px";
        this.container.style.width = "100%";
        this.container.style.overflowX = "scroll";
        this.container.style.overflowY = "scroll";

        let table = document.createElement('table');
        table.style.backgroundColor = '#ffffff';
        table.classList.add('table', 'table-hover', 'table-sm', 'mb-0');

        let tHead = this.createTableHead();
        let tBody = document.createElement('tbody');

        table.appendChild(tHead);
        table.appendChild(tBody);
        this.container.appendChild(table);

        let footerDiv = document.createElement('div');
        footerDiv.classList.add('text-sm', 'text-end', 'text-muted', 'py-1');
        let spanText = document.createElement('span');
        spanText.innerHTML = 'Elementos:';
        let spanIndicator = document.createElement('span');
        spanIndicator.id = 'count_' + this.id;
        footerDiv.appendChild(spanText);
        footerDiv.appendChild(spanIndicator);

        this.container.parentNode.insertBefore(footerDiv, this.container.nextSibling);

        this.renderData();
    }

    renderData() {
        let tBody = this.container.querySelectorAll('tbody')[0];
        tBody.innerHTML = '';
        let count = 0;

        let filteredData = this.data;

        if (this.sortBy.length > 0 && this.sortDesc) {
            filteredData = filteredData.sort((a, b) => {
                return (a[this.sortBy] < b[this.sortBy]) ? 1 : -1;
            });
        }
        else if (this.sortBy.length > 0) {
            filteredData = filteredData.sort((a, b) => {
                return (a[this.sortBy] > b[this.sortBy]) ? 1 : -1;
            });
        }
        else {
            filteredData = filteredData.sort((a, b) => {
                let propName = Object.keys(a)[0];
                return (a[propName] > b[propName]) ? 1 : -1;
            });
        }

        for (let i = 0; i < filteredData.length; i++) {
            let tr = document.createElement('tr');

            let show = true;

            //filter data
            if (this.activeFilters.length > 0) {
                let dataEl = filteredData[i];
                for (let k = 0; k < this.activeFilters.length; k++) {
                    let dataValue = KorGrid.getValueByNavigationProperty(dataEl, this.activeFilters[k].propertyName);
                    dataValue = KorGrid.removeAccents(dataValue.trim().toLowerCase());
                    let filterValue = this.activeFilters[k].value.trim().toLowerCase();
                    if (filterValue.length > 0 && dataValue.indexOf(filterValue) <= -1) {
                        show = false;
                        break;
                    }
                }
            }

            if (show) {
                for (let j = 0; j < this.colsDef.length; j++) {
                    let td = document.createElement('td');
                    td.classList.add('text-nowrap');

                    if (this.colsDef[j].classNames) {
                        for (let h = 0; h < this.colsDef[j].classNames.length; h++) {
                            td.classList.add(this.colsDef[j].classNames[h]);
                        }
                    }

                    if (this.colsDef[j].renderer && typeof this.colsDef[j].renderer === 'function') {
                        td.innerHTML = this.colsDef[j].renderer(filteredData[i]);
                    }
                    else if (this.colsDef[j].isDate) {
                        let dateValue = KorGrid.getValueByNavigationProperty(filteredData[i], this.colsDef[j].propertyName);
                        let mDate = moment(dateValue);
                        if (mDate.isValid()) {
                            td.innerHTML = mDate.format('DD/MM/YYYY hh:mm A');
                        }
                        else {
                            td.innerHTML = '-';
                        }
                    }
                    else {
                        td.innerHTML = KorGrid.getValueByNavigationProperty(filteredData[i], this.colsDef[j].propertyName);
                    }
                    tr.appendChild(td);
                }
                tBody.appendChild(tr);
                count++;
            }
        }
        let spanIndicator = document.getElementById('count_' + this.id);
        spanIndicator.innerHTML = count;

        var tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        for (var i = 0; i < tooltips.length; i++) {
            new bootstrap.Tooltip(tooltips[i]);
        }
    }

    createTableHead() {
        let tHead = document.createElement('thead');
        tHead.style.position = "sticky";
        tHead.style.top = 0;
        tHead.style.backgroundColor = "#ffffff";

        let tRow = document.createElement('tr');

        for (let i = 0; i < this.colsDef.length; i++) {
            let colDef = this.colsDef[i];
            let th = document.createElement('th');
            th.classList.add('py-1', 'px-2');
            th.classList.add('text-nowrap', 'align-top');

            if (colDef.width) {
                th.style.width = colDef.width;
            }

            let hSpan = document.createElement('span');
            if (colDef.header) {
                hSpan.innerHTML = colDef.header;
                th.appendChild(hSpan);
            }

            if (colDef.headerClassNames) {
                for (let h = 0; h < colDef.headerClassNames.length; h++) {
                    th.classList.add(colDef.headerClassNames[h]);
                }
            }

            if (colDef.sortable) {
                hSpan.style.cursor = "pointer";
                hSpan.setAttribute('propName', colDef.propertyName);

                hSpan.addEventListener('click', () => {
                    let attrValue = hSpan.getAttribute('propName');
                    if (this.sortBy != '' && this.sortBy != attrValue) {
                        this.sortSpans.forEach((_, indx) => {
                            this.sortSpans[indx].classList.remove('text-info');
                            let iconsToRemove = this.sortSpans[indx].querySelectorAll('i');
                            iconsToRemove.forEach((toRem) => {
                                this.sortSpans[indx].removeChild(toRem);
                            });
                        });
                        hSpan.classList.add('text-info');
                        let sortIcon = document.createElement('i');
                        sortIcon.classList.add('mdi', 'mdi-sort-ascending');
                        hSpan.prepend(sortIcon);
                        this.sortBy = attrValue;
                        this.sortDesc = false;
                    }
                    else if (this.sortBy == '') {
                        this.sortBy = attrValue;
                        this.sortDesc = false;
                        hSpan.classList.add('text-info');
                        let sortIcon = document.createElement('i');
                        sortIcon.classList.add('mdi', 'mdi-sort-ascending');
                        hSpan.prepend(sortIcon);
                    }
                    else if (this.sortBy == attrValue && !this.sortDesc) {
                        this.sortDesc = true;
                        hSpan.removeChild(hSpan.firstChild);
                        let sortIcon = document.createElement('i');
                        sortIcon.classList.add('mdi', 'mdi-sort-descending');
                        hSpan.prepend(sortIcon);
                    }
                    else {
                        hSpan.classList.remove('text-info');
                        hSpan.removeChild(hSpan.firstChild);
                        this.sortBy = '';
                        this.sortDesc = false;
                    }

                    this.renderData();
                });

                this.sortSpans.push(hSpan);
            }

            if (colDef.filter) {
                let icon = document.createElement('i');
                icon.classList.add('mdi', 'mdi-filter');
                icon.style.cursor = "pointer";

                icon.addEventListener('click', () => {
                    let inputContainer = document.getElementById('filterCont_' + colDef.propertyName);
                    if (inputContainer.classList.contains('d-none')) {
                        inputContainer.classList.remove('d-none');
                        this.activeFilters.push({
                            propertyName: colDef.propertyName,
                            value: ''
                        });
                    }
                    else {
                        inputContainer.children[0].value = '';
                        inputContainer.classList.add('d-none');
                        this.activeFilters = this.activeFilters.filter(function (obj) {
                            return obj.propertyName != colDef.propertyName;
                        });
                    }
                    this.renderData();
                });
                th.prepend(icon);
            }
            if (colDef.filter == 'textFilter') {
                let inputContainer = document.createElement('div');
                inputContainer.id = 'filterCont_' + colDef.propertyName;
                inputContainer.classList.add('d-none');
                let input = document.createElement('input');
                input.classList.add('form-control', 'form-control-sm');
                input.style.minHeight = 'auto';
                input.style.padding = '3px 5px';
                input.style.fontSize = '0.7rem';
                input.addEventListener('keyup', () => {
                    let filterIndex = this.activeFilters.findIndex(a => a.propertyName == colDef.propertyName);
                    this.activeFilters[filterIndex].value = input.value;
                    this.renderData();
                });
                inputContainer.appendChild(input);
                th.appendChild(inputContainer);
            }
            if (colDef.filter == 'comboBoxFilter') {
                let inputContainer = document.createElement('div');
                inputContainer.id = 'filterCont_' + colDef.propertyName;
                inputContainer.classList.add('d-none');
                let select = document.createElement('select');
                select.classList.add('form-select', 'form-control-sm');
                select.style.minHeight = 'auto';
                select.style.padding = '3px 5px';
                select.style.fontSize = '0.7rem';

                let defaultOption = document.createElement('option');
                defaultOption.innerHTML = 'Mostrar todos';
                defaultOption.value = '';
                select.appendChild(defaultOption);

                let insertedValues = [];
                for (let j = 0; j < this.data.length; j++) {
                    let optionValue = KorGrid.getValueByNavigationProperty(this.data[j], colDef.propertyName);
                    if (!insertedValues.includes(optionValue)) {
                        insertedValues.push(optionValue);
                        let option = document.createElement('option');
                        option.innerHTML = optionValue;
                        option.value = optionValue;
                        select.appendChild(option);
                    }
                }

                select.addEventListener('change', () => {
                    let filterIndex = this.activeFilters.findIndex(a => a.propertyName == colDef.propertyName);
                    this.activeFilters[filterIndex].value = select.value;
                    this.renderData();
                });
                inputContainer.appendChild(select);
                th.appendChild(inputContainer);
            }


            tRow.appendChild(th);
        }

        tHead.appendChild(tRow);
        return tHead;
    }

    static removeAccents(data) {
        if (data.normalize) {
            return data + ' ' + data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }
        return data;
    }

    static getValueByNavigationProperty(obj, propertyName) {
        if (propertyName.indexOf('.') > -1) {
            let props = propertyName.split('.');
            let value = obj;
            for (let m = 0; m < props.length; m++) {
                value = value[props[m]];
            }
            return value;
        }
        else {
            return obj[propertyName];
        }
    }
}
